import React, { useState } from "react"
import { useSelector } from "react-redux"

import { VIEW, EDIT, YES } from "const"
import { projectsRoute } from "client/parts/routes"
import { StoreType } from "client/store"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import ProjectContent from "client/parts/projectContent"
import List from "./list"
import View from "./view"
import Edit from "./edit"

const Project = () => {
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const modals = useSelector((state: StoreType) => state.system.modals)

    const [modalLength] = useState(modals.length)

    const { projectModuleAccess } = packageSettings
    const access = userData.accountId !== 1 && projectModuleAccess === YES

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                exact
                path={projectsRoute}
                component={List}
            />
            <Route
                path={`${projectsRoute}/${VIEW}/:projectId`}
                component={modalLength ? ProjectContent : View}
            />
            <Route
                path={`${projectsRoute}/${EDIT}/:projectId`}
                component={Edit}
            />
        </Switch>
    )
}
export default Project
